// Function to scroll to the anchor
function scrollToAnchor(hash) {
  if (hash) {
    $('html, body').animate({
      scrollTop: $(hash).offset().top
    }, 150);
  }
}

// Function to scroll to the anchor with a delay
function scrollToAnchorWithDelay(hash) {
  setTimeout(function() {
    scrollToAnchor(hash);
  }, 500); // Adjust the delay as needed
}

// allow hashtags to target and open accordions
function openAccordionWithAnchor(hash) {

    var targetAccordion = $(hash).closest('.accordion-item');
    var targetAccordionButton = targetAccordion.find('.accordion-button');
    var targetAccordionPanel = targetAccordion.find('.accordion-collapse');

    // If anchor is inside an accordion then scroll to the panel
    if (targetAccordion.length){

        targetAccordionButton.removeClass('collapsed');
        targetAccordionButton.attr('aria-expanded', 'true');
        targetAccordionPanel.addClass('show');

        // Scroll to the panel with a delay
        scrollToAnchorWithDelay(hash);

    }

}

// Check for anchor in URL and scroll to it on page load
if (window.location.hash != "") {
    if (window.location.href.indexOf(window.location.hash) > -1) {
        openAccordionWithAnchor(window.location.hash);
    }
}

// open accordion with an anchor whenever an anchor is clicked
$('a[href*="#"').on('click', function(event) {
    //check hostname and URL before navigating away
    //https://stackoverflow.com/questions/6263454/get-relative-url-from-absolute-url

    let targetURL = event.target.href,
        currentURL = window.location.href;
        targetA = document.createElement('a'),
        currentA = document.createElement('a'),
        targetA.href = targetURL,
        currentA.href = currentURL;

    if(targetA.host == currentA.host) {
        if(targetA.pathname == currentA.pathname) {
            //link within the same page, open current accordion
            openAccordionWithAnchor(event.target.hash);
        }
    }
});
